import Skeleton from "react-loading-skeleton";
import 'react-loading-skeleton/dist/skeleton.css'

export function CustomSkeletonLoader() {
    return (
        <Skeleton/>
        )
}